"use client";

import { c as _c } from "react/compiler-runtime";
import { useIsCheckoutRoute } from "@/hooks/useIsCheckoutRoute";
import { useCart } from "@/queries/useCart";
import { CartCheckoutButton } from "./CartCheckoutButton";
import { CompleteCheckoutButton } from "./CompleteCheckoutButton";
import { PromoCode } from "./PromoCode/PromoCode";
export function CartFooter() {
  const $ = _c(3);
  const {
    data: cart
  } = useCart();
  const isCheckoutRoute = useIsCheckoutRoute();
  if (!cart?.items?.length) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PromoCode />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isCheckoutRoute) {
    t1 = <div className="flex flex-col gap-4 border-t border-neutral-200 bg-white p-5">{t0}{isCheckoutRoute ? <CompleteCheckoutButton /> : <CartCheckoutButton />}</div>;
    $[1] = isCheckoutRoute;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}